<template>
  <span class="cf-channel-pill" :style="pillStyle">
    <v-icon x-small :color="brand.color" class="mr-1">{{ brand.icon }}</v-icon>
    <span class="cf-channel-pill__label">{{ displayName }}</span>
  </span>
</template>

<script>
import { getChannelBrand } from "../utils/channelBranding";

export default {
  name: "ChannelPill",
  props: {
    type: { type: String, default: "" },
    name: { type: String, default: "" },
  },
  computed: {
    brand() {
      return getChannelBrand(this.type);
    },
    displayName() {
      return this.name || this.brand.label;
    },
    pillStyle() {
      return {
        background: this.brand.light,
        borderColor: `${this.brand.color}33`,
      };
    },
  },
};
</script>

<style scoped>
.cf-channel-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px 2px 4px;
  border-radius: 12px;
  border: 1px solid transparent;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.2;
  max-width: 100%;
}

.cf-channel-pill__label {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #3b4a54;
}
</style>
